import { createObservableOperation } from 'owa-observable-operation';
import getUpsLocationForCollaboratorsInBuildingToday from '../services/getUpsLocationForCollaboratorsInBuildingToday';

import type { CollaboratorSource } from 'hybridspace-common/lib/serviceTypes';
import type { TraceErrorObject } from 'owa-analytics-types';
import type { UPSCollaborator } from '../types/UPSCollaborator';

const dest = createObservableOperation(
    'PLACES_LOAD_UPS_BUILDING_LOCATIONS',
    (
        collaboratorsEmails: string[],
        collaboratorCategory: CollaboratorSource
    ): {
        collaboratorsEmails: string[];
        collaboratorCategory: CollaboratorSource;
    } => ({
        collaboratorsEmails,
        collaboratorCategory,
    }),
    ({ collaboratorCategory }) => collaboratorCategory as string,
    ({ collaboratorsEmails }) => getUpsLocationForCollaboratorsInBuildingToday(collaboratorsEmails)
);
const getUpsCollaboratorsBuildingLocationsLastError: (key: string) => TraceErrorObject | undefined =
    dest.getLastError;
const loadUpsCollaboratorsBuildingLocations: (
    collaboratorsEmails: string[],
    collaboratorCategory: CollaboratorSource
) => {
    collaboratorsEmails: string[];
    collaboratorCategory: CollaboratorSource;
} = dest.start;
const loadUpsCollaboratorsBuildingLocationsInProgress: (key: string) => boolean = dest.isInProgress;
const loadUpsCollaboratorsBuildingLocationsSucceeded: (
    actionMessage: {
        collaboratorsEmails: string[];
        collaboratorCategory: CollaboratorSource;
    } & {
        result: UPSCollaborator[];
    }
) => {
    collaboratorsEmails: string[];
    collaboratorCategory: CollaboratorSource;
} & {
    result: UPSCollaborator[];
} = dest.onSucceeded;

export {
    getUpsCollaboratorsBuildingLocationsLastError,
    loadUpsCollaboratorsBuildingLocations,
    loadUpsCollaboratorsBuildingLocationsInProgress,
    loadUpsCollaboratorsBuildingLocationsSucceeded,
};
